import { Link } from "react-router-dom"
import { TaskStatusIcon } from "../TaskChangeIcon"
import { TaskTypeIcon } from "../TaskTypeIcon"
import "react-loading-skeleton/dist/skeleton.css"

interface TaskList {
  taskId: string
  taskName: string
  taskType: string
  changeType: string
}

export const TimelineTasksDisplaySidebar = (props: { tasks: TaskList[] }) => {
  const { tasks } = props

  return (
    <ul className="list">
      {tasks.map((task: any, index: any) => (
        <li className="list-item group border-bottom" key={index}>
          <Link to={`/tasks/${task.taskId}`}>
            <div className="group-items">
              <TaskStatusIcon taskStatus={getTaskStatus(task)} />
              <TaskTypeIcon type={task.taskType} />
              <span className="text two-lines-then-ellipsis">{task.taskName}</span>
            </div>
          </Link>
        </li>
      ))}
    </ul>
  )
}

const getTaskStatus = (task: TaskList) => task.changeType
